<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Add Tx Keyword Guide</h3>
      </div>
    </div>
  </div>
</div>

<table  class="table table-striped table-bordered mt-3 text-center" style="width:100%" *ngFor="let data of dataList">
  <thead >
    <tr><th colspan="3">Source: {{data.source}}</th></tr>
    <tr class="thead-dark">
      <th>Required Field</th>
      <th>Reference Parameter</th>
      <th>Remark</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let field of data.fieldList">
      <td>{{field.name}}</td>
      <td>{{field.reference}}</td>
      <td class="text-left">{{field.remark}}</td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="3">*** **************************************************************************** ***</td>
    </tr>
    <tr>
      <td colspan="3">*** --- <span class="font-italic text-warning font-weight-bold text-uppercase">In the face of ambiguity, refuse the temptation to guess.</span>  --- ***</td></tr>
    <tr>
      <td colspan="3">*** **************************************************************************** ***</td>
    </tr>
  </tfoot>
</table>

<!-- <div class="table-responsive"> -->

